import GoogleMeetServices from "../../../services/GoogleMeetService";

const GoogleProvider = {
  // Returns a truthy connection marker (never a real token — Google Meet tokens live server-side).
  async getValidAccessToken() {
    const status = await GoogleMeetServices.getConnectionStatus();
    return status?.connected ? true : null;
  },

  async createMeeting(payload) {
    const connected = await this.getValidAccessToken();
    if (!connected) throw new Error("Google Meet not authenticated");

    return GoogleMeetServices.createUserMeeting(payload);
  },

  async updateMeeting(meetingId, payload) {
    const connected = await this.getValidAccessToken();
    if (!connected) throw new Error("Google Meet not authenticated");

    return GoogleMeetServices.updateUserMeeting(meetingId, payload);
  },

  async getUpcomingMeetings() {
    return GoogleMeetServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId) {
    return GoogleMeetServices.deleteMeeting(meetingId);
  },

  async deleteExpiredMeetings() {
    return GoogleMeetServices.deleteExpiredMeetings();
  },

  getName() {
    return "Google Meet";
  }
};

export default GoogleProvider;
